import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { editorStore } from '../../stores/EditorStore';
import { Heading1Base } from '../shared/Heading';
export const TranslationHeader = observer(({
  titleKey
}) => {
  const {
    t
  } = useTranslation();
  const {
    sessionModule
  } = editorStore;
  const title = t(titleKey);

  if (sessionModule) {
    return /*#__PURE__*/React.createElement(Heading1Base, null, t("translation.title_for_module", {
      title,
      workshop: sessionModule.workshopName,
      module: sessionModule.moduleName
    }));
  } else {
    return /*#__PURE__*/React.createElement(Heading1Base, null, t("translation.title_for_core_game", {
      title
    }));
  }
});